import replaceAll from "string.prototype.replaceall";

replaceAll.shim();
